module.exports = __webpack_public_path__ + "img/icon-star.2cfbf481.png";